import {
    REGISTER_LMS_USER_STARTED,
    REGISTER_LMS_USER_SUCCEEDED,
    REGISTER_LMS_USER_FAILED,
    LOADING_USERPROFILE_STARTED,
    LOAD_USERPROFILE_SUCCEEDED,
    LOAD_USERPROFILE_FAILED,
    VERIFY_LMS_USER_STARTED,
    VERIFY_LMS_USER_FAILED,
    VERIFY_LMS_USER_SUCCEEDED,
    ARE_SEATS_AVAILABLE_STARTED,
    ARE_SEATS_AVAILABLE_FAILED,
    ARE_SEATS_AVAILABLE_SUCCEEDED,
    VerifyLmsUserResult,
    AreSeatsAvailableResult,
    SelfRegistrationActionTypes,
    SelfRegistrationModel,
    LMSUserViewModel,
    RegisterLMSUserResult,
    RETRIEVE_DECRYPTED_ORDER_FAILED,
    RETRIEVE_DECRYPTED_ORDER_STARTED,
    RETRIEVE_DECRYPTED_ORDER_SUCCEEDED,
    RETRIEVE_DECRYPTED_PROFILE_FAILED,
    RETRIEVE_DECRYPTED_PROFILE_STARTED,
    RETRIEVE_DECRYPTED_PROFILE_SUCCEEDED,
    RETRIEVE_ENCRYPTED_PROFILE_FAILED,
    RETRIEVE_ENCRYPTED_PROFILE_STARTED,
    RETRIEVE_ENCRYPTED_PROFILE_SUCCEEDED
} from './types';

import {
LOAD_MEMBERSHIPS_FAILED,
LOAD_MEMBERSHIPS_STARTED,
LOAD_MEMBERSHIPS_SUCCEEDED
}
from '../memberships/types'

const initialProfile = {
    email : '',
    firstName : '',
    lastName : '',
    title: '',
    organizationname: '',
    department : '',
    address : '',
    city : '',
    stateorProvince : '',
    country : '',
    postalCode : '',
    phone : '',
    addressType : 0,
    sourceUrl: '',
    error : undefined,
    crmGuid: '',
    subscriptions: [],
    activated: false
};

const initialVerify = {
  memberships: [],
  orderNumber: '',
  password: '',
  profileId: '',
  error: undefined,
  activated: false
}

const initialVerifyViewModel = {
  errorMessage: '',
  verificationData: initialVerify,
  verifyLMSUserResult: { userProfile: {subscriptions : [], userName: '' }, message: '', success: false },
}

const initialSeatsAvailableResult = {
  message: '',
  success: false
}

const userProfileSavedResult = {
  message: '',
  success: false
}


const initialState = {
  error : '',
  orderNumber: '',
  profileId: '',
  userProfileExists: false,
  userLMSProfileSavedResult: userProfileSavedResult,
  areSeatsAvailableResult: initialSeatsAvailableResult,
  userProfileData : initialProfile,
  verifyLMSUserData: initialVerifyViewModel,
  memberships: [],
  loading: true
};



const reducer = (
    state = initialState,
    action: SelfRegistrationActionTypes
): SelfRegistrationModel => {
    switch (action.type) {
      case LOAD_MEMBERSHIPS_STARTED: {
        return {
          ...state,
          loading:true
        };
      }
      case LOAD_MEMBERSHIPS_SUCCEEDED: {
        return {
          ...state,
          memberships : action.payload,
          loading:false
        };
      }

      case LOAD_MEMBERSHIPS_FAILED: {
        return {
          ...state,
          loading:false
        };
      }

      case LOADING_USERPROFILE_STARTED: {
        return {
            ...state,
            userProfileExists: false,
            loading:true
        };
    }
    case LOAD_USERPROFILE_SUCCEEDED: {
        return {
            ...state,
            userProfileData: (action.payload as unknown) as LMSUserViewModel,
            userProfileExists : ((action.payload as unknown) as LMSUserViewModel).activated &&  ((action.payload as unknown) as LMSUserViewModel).organizationname != "",
            loading: false
        };
    }
    case LOAD_USERPROFILE_FAILED: {
        return {
            ...state,
            userProfileExists: false,
            error: action.payload,
            loading:false
        };
    }

        case REGISTER_LMS_USER_STARTED: {
            return {
                ...state,
                loading:true
            };
        }
        case REGISTER_LMS_USER_SUCCEEDED: {
            return {
                ...state,
                userLMSProfileSavedResult: (action.payload as unknown) as RegisterLMSUserResult,
                loading: false
            };
        }
        case REGISTER_LMS_USER_FAILED: {
            return {
                ...state,
                error: action.payload,
                loading:false
            };
        }

        case VERIFY_LMS_USER_STARTED: {
          return {
              ...state,
              loading:true
          };
      }
      case VERIFY_LMS_USER_FAILED: {
          return {
              ...state,
              error: action.payload,
              loading:false
          };
      }
      case VERIFY_LMS_USER_SUCCEEDED: {
          return {
              ...state,
              error: !(((action.payload as unknown) as VerifyLmsUserResult).message == "success" ) ? ((action.payload as unknown) as VerifyLmsUserResult).message : "",
              verifyLMSUserData: {
                verificationData: {
                  ...state.verifyLMSUserData.verificationData
                },
                verifyLMSUserResult: {
                   userProfile:((action.payload as unknown) as VerifyLmsUserResult).userProfile,
                   message: ((action.payload as unknown) as VerifyLmsUserResult).message,
                   success: ((action.payload as unknown) as VerifyLmsUserResult).message == "success"
                }
              },
              loading: (false || ((action.payload as unknown) as VerifyLmsUserResult).message == "success"),
            };
      }
      case ARE_SEATS_AVAILABLE_STARTED: {
          return {
              ...state,
              loading:true
          };
      }
      case ARE_SEATS_AVAILABLE_FAILED: {
          return {
              ...state,
              error: action.payload,
              loading:false
          };
      }
      case ARE_SEATS_AVAILABLE_SUCCEEDED: {
          return {
              ...state,
              areSeatsAvailableResult: (action.payload as unknown) as AreSeatsAvailableResult,
              loading:false
          };
      }

      case RETRIEVE_DECRYPTED_ORDER_STARTED: {
        return {
            ...state,
            loading: true
        };
    }
    case RETRIEVE_DECRYPTED_ORDER_FAILED: {
        return {
            ...state,
            error: action.payload,
            loading: false
        };
    }
    case RETRIEVE_DECRYPTED_ORDER_SUCCEEDED: {
        return {
            ...state,
            orderNumber: action.payload,
            loading: false

        };
    }
    case RETRIEVE_DECRYPTED_PROFILE_STARTED: {
      return {
          ...state,
          loading: true
      };
  }
  case RETRIEVE_DECRYPTED_PROFILE_FAILED: {
      return {
          ...state,
          error: action.payload,
          loading: false
      };
  }
  case RETRIEVE_DECRYPTED_PROFILE_SUCCEEDED: {
      return {
          ...state,
          profileId: action.payload,
          loading: false

      };
  }

  case RETRIEVE_ENCRYPTED_PROFILE_STARTED: {
    return {
        ...state,
        loading: true
    };
}
case RETRIEVE_ENCRYPTED_PROFILE_FAILED: {
    return {
        ...state,
        error: action.payload,
        loading: false
    };
}
case RETRIEVE_ENCRYPTED_PROFILE_SUCCEEDED: {
    return {
        ...state,
        profileId: action.payload,
        loading: false

    };
}

        default: {
            return state;
        }
    }
};

export default reducer;
